<template>
  <div class="zcxy">
    <div class="clearfix table-tools">
      <div class="buttons">
        <a-form layout='inline'>
          <a-form-item>
            <a-button icon="check" type="primary" @click="recoveryItem()">批量过</a-button>
          </a-form-item>
          <a-form-item>
            <a-button icon="delete" @click="deleteItem()">批量不过</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="search">
        <a-form layout='inline'>
          <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>评论状态</span>
              </template>
              <a-select allowClear v-model="searchData.status" placeholder="请选择评论状态" style="width: 140px">
                <a-select-option v-for="(d, index) of commentStatus" :key="index" :value="d['value']">{{ d['label'] }}</a-select-option>
              </a-select>
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>添加时间</span>
              </template>
              <a-range-picker
              style="width: 240px"
              :ranges="rangesData"
              v-model='searchData.add'
              allowClear
              @change="(val,time)=>handleTime(val,time,'add')" />
            </a-tooltip>
          </a-form-item>
          <a-form-item v-if="canIndex">
            <a-button type="primary" @click="searchList">搜索</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div class="table">
      <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>
      <a-table size="middle" :pagination="false" :bordered='false' rowKey="comment_id"
        :selection="{key: 'key'}"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :columns="columns" :dataSource="list">
        <template slot="index" slot-scope="text, record , index">
          <span>{{(index+1) + pageParams.perPage * (pageParams.currentPage - 1)}}</span>
        </template>
        <template slot="images" slot-scope="text, record">
          <LImg :preview="0" v-for="(image, index) of record.comment_images" :key="index"  
            :src="image" style="width: 44px; height: 44px; margin: 0 5px 5px 0"/>
        </template>
        <template slot="action" slot-scope="text,record">
          <a href="javascript:;" @click="recoveryItem(record)">过</a>
          <a-divider type="vertical" />
          <a href="javascript:;" @click="deleteItem(record)">不过</a>
        </template>
      </a-table>
    </div>
    <div class="page">
      <a-pagination
        :pageSizeOptions="pageSizeOptions"
        :total="pageParams.totalCount"
        showSizeChanger
        :pageSize="pageParams.perPage"
        v-model="current"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
          :showTotal="total => `共 ${pageParams.totalCount.toLocaleString()}条 `"
      >
          <template slot='buildOptionText' slot-scope='props'>
            <span v-if="props.value!=='100'">{{props.value}}条/页</span>
            <span v-if="props.value==='100'">100条/页</span>
          </template>
        </a-pagination>
    </div>
  </div>
</template>

<script>
const columns = [
  { title: '#', width:'55px', scopedSlots: { customRender: 'index' }, key: 'index', fixed: 'left'},
  { title: '留言用户', width: '100px', dataIndex: 'student_name', key: 'name', fixed: 'left' },
  { title: '标题内容', width: '150px', dataIndex: 'content_title', key: '1' },
  { title: '留言内容', dataIndex: 'comment_content', key: '2' },
  { title: '留言图片', dataIndex: 'comment_images', key: '3' ,scopedSlots: { customRender: 'images' }},
  { title: '点赞数', width: '60px', dataIndex: 'like_count', key: '4',align:"center" },
  { title: '评论状态', width: '74px', dataIndex: 'status', key: '5' ,align:"center"},
  { title: '留言时间', width: '130px', dataIndex: 'created_at', key: '6' },
  { title: '操作', key: 'operation', width: 80, fixed: 'right', scopedSlots: { customRender: 'action' }},
]

import moment from 'moment'
import C_ITEMS from '@/utils/items'
import ranges from "@/common/mixins/ranges"
import authority from '@/common/mixins/authority'
import tableMixins from '@/common/mixins/table'
export default {
  name: 'gjjl',

  data() {
    return {
      loading: false,
      pageSizeOptions: ['10', '20', '30', '40', '100'],
      current: 1,
      pageParams: {
        currentPage: 1,
        pageCount: 50,
        perPage: 10,
        totalCount: 0
      },
      columns,
      searchParams: {
        "page": 1,
        "per-page": 10,
        "search": {},
        "sort": ''
      },
      list: [],
      current: 1,

      commentStatus: C_ITEMS.commentStatus,

      searchData: {},
      selectedRowKeys: [],
      visible: false,
      authType:['market','content'],
    }
  },
  mixins: [ authority , tableMixins, ranges ],

  methods: {
    closeSearch() {
      this.visible = false
    },
    async getList() {
      if(!this.canIndex){
          this.$message.warning('您暂无权限!!')
          return false
      }
      this.loading = true
      let obj = {}
      let { searchData } = this
      if (searchData) {
        for (let k in searchData) {
          if (k === 'add') {
            obj['start_date'] = searchData[k][0]?moment(searchData[k][0]).format('YYYY-MM-DD'):''
            obj['end_date'] = searchData[k][1]?moment(searchData[k][1]).format('YYYY-MM-DD'):''
          } else {
            obj[k] = searchData[k]
          }
        }
      }
      this.searchParams.search = obj
      let res = await this.$store.dispatch('knowledgeContentCommentAction', { data: this.searchParams })
      this.list = res.items
      this.pageParams = res._meta
      this.loading = false
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    deleteItem(item) {
      if (item) {
        this.selectedRowKeys = [item.comment_id]
      }
      if (this.selectedRowKeys.length <= 0) {
        return 
      }
      let that = this
      this.$confirm({
        title: `您确定要删除吗？`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return new Promise(async (resolve, reject) => {
            let res = await that.$store.dispatch('knowledgeContentCommentRefuseAction', { data: { comment_id: that.selectedRowKeys } })
            if (res) {
              that.selectedRowKeys = []
              that.getList()
              resolve(res)
            }
          }).catch(error => console.log(error))
        }
      })
    },
    recoveryItem(item) {
      if (item) {
        this.selectedRowKeys = [item.comment_id]
      }
      if (this.selectedRowKeys.length <= 0) {
        return 
      }
      let that = this
      this.$confirm({
        title: `您确定要审核吗？`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return new Promise(async (resolve, reject) => {
            let res = await that.$store.dispatch('knowledgeContentCommentComfirmAction', { data: { comment_id: that.selectedRowKeys } })
            if (res) {
              that.selectedRowKeys = []
              that.getList()
              resolve(res)
            }
          }).catch(error => console.log(error))
        }
      })
    },
    handleTime(val,time,name){
        this.searchData[name] = val
        this.$forceUpdate()
    },
  }
}
</script>
